(function () {
  'use strict';

  var TRACKED_PATHS = {
    selector: '/pages/private-consultation',
    contact: '/pages/contact',
    liverpool: '/pages/private-bespoke-appointment-liverpool',
    savileRow: '/pages/private-bespoke-appointment-london',
    homeVisit: '/pages/private-home-visits-for-bespoke-tailoring-signature-bespoke',
    international: '/pages/private-international-tailoring-consultations-signature-bespoke'
  };

  var eventQueue = [];
  var queueTimer = null;

  function getPath() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function publishNow(eventName, payload) {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(eventName, payload || {});
      return true;
    }

    return false;
  }

  function flushQueue() {
    if (!eventQueue.length) {
      if (queueTimer) {
        window.clearInterval(queueTimer);
        queueTimer = null;
      }
      return;
    }

    var remaining = [];

    eventQueue.forEach(function (item) {
      if (!publishNow(item.name, item.payload)) {
        remaining.push(item);
      }
    });

    eventQueue = remaining;

    if (!eventQueue.length && queueTimer) {
      window.clearInterval(queueTimer);
      queueTimer = null;
    }
  }

  function publish(eventName, payload) {
    if (publishNow(eventName, payload)) {
      return;
    }

    eventQueue.push({ name: eventName, payload: payload || {} });

    if (!queueTimer) {
      var attempts = 0;
      queueTimer = window.setInterval(function () {
        attempts += 1;
        flushQueue();

        if (attempts >= 20 && queueTimer) {
          window.clearInterval(queueTimer);
          queueTimer = null;
          eventQueue = [];
        }
      }, 500);
    }
  }

  function bookingLocationFromPath(path) {
    if (path === TRACKED_PATHS.liverpool) return 'liverpool';
    if (path === TRACKED_PATHS.savileRow) return 'savile_row';
    if (path === TRACKED_PATHS.homeVisit) return 'home_visit';
    if (path === TRACKED_PATHS.international) return 'international';
    return null;
  }

  function locationFromHref(href) {
    if (!href) return null;

    var url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }

    var path = url.pathname.replace(/\/$/, '');
    return bookingLocationFromPath(path);
  }

  function trackPageState() {
    var path = getPath();

    if (path === TRACKED_PATHS.selector) {
      publishPendingConsultationCta();

      publish('sb_consultation_selector_view', {
        page_path: path,
        page_title: document.title
      });
    }

    if (path === TRACKED_PATHS.contact) {
      publish('sb_private_enquiry_page_view', {
        page_path: path,
        page_title: document.title
      });

      if (document.querySelector('.Alert--success')) {
        publish('sb_private_enquiry_complete', {
          page_path: path,
          page_title: document.title
        });
      }
    }

    var bookingLocation = bookingLocationFromPath(path);

    if (bookingLocation) {
      publish('sb_booking_page_view', {
        booking_location: bookingLocation,
        page_path: path,
        page_title: document.title
      });

      detectCowlendarWidget(bookingLocation, path);
    }
  }

  function detectCowlendarWidget(bookingLocation, path) {
    var attempts = 0;
    var maxAttempts = 20;
    var timer = window.setInterval(function () {
      attempts += 1;

      var widget = document.querySelector('[data-cowlendar-inline]');

      if (widget) {
        window.clearInterval(timer);
        publish('sb_booking_widget_present', {
          booking_location: bookingLocation,
          booking_id: widget.getAttribute('data-cowlendar-inline') || '',
          page_path: path
        });
        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  function trackConsultationCta(event) {
    var path = getPath();

    if (path === TRACKED_PATHS.selector) {
      return;
    }

    var link = event.target.closest('a[href]');

    if (!link) {
      return;
    }

    var url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== TRACKED_PATHS.selector) {
      return;
    }

    var payload = {
      source_page_path: path,
      destination_path: TRACKED_PATHS.selector,
      link_text: (link.textContent || '').trim()
    };

    try {
      window.sessionStorage.setItem('sb_pending_consultation_cta', JSON.stringify(payload));
    } catch (error) {
      publish('sb_consultation_cta_click', payload);
    }
  }

  function publishPendingConsultationCta() {
    var rawPayload;

    try {
      rawPayload = window.sessionStorage.getItem('sb_pending_consultation_cta');
    } catch (error) {
      return;
    }

    if (!rawPayload) {
      return;
    }

    try {
      publish('sb_consultation_cta_click', JSON.parse(rawPayload));
    } catch (error) {
      window.sessionStorage.removeItem('sb_pending_consultation_cta');
      return;
    }

    window.sessionStorage.removeItem('sb_pending_consultation_cta');
  }

  function trackLocationSelection(event) {
    var path = getPath();

    if (path !== TRACKED_PATHS.selector) {
      return;
    }

    var link = event.target.closest('a[href]');

    if (!link) {
      return;
    }

    var location = locationFromHref(link.href);

    if (!location) {
      return;
    }

    publish('sb_consultation_location_select', {
      consultation_location: location,
      source_page_path: path,
      destination_path: new URL(link.href, window.location.origin).pathname,
      link_text: (link.textContent || '').trim()
    });
  }

  function trackPrivateEnquiryClick(event) {
    var link = event.target.closest('a[href]');

    if (!link) {
      return;
    }

    var url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== TRACKED_PATHS.contact) {
      return;
    }

    publish('sb_private_enquiry_click', {
      source_page_path: getPath(),
      destination_path: TRACKED_PATHS.contact,
      link_text: (link.textContent || '').trim()
    });
  }

  function trackWhatsAppClick(event) {
    var link = event.target.closest('a[href]');

    if (!link) {
      return;
    }

    var url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.hostname !== 'wa.me' || url.pathname.replace(/\/$/, '') !== '/447805093836') {
      return;
    }

    publish('sb_whatsapp_click', {
      source_page_path: getPath(),
      link_text: (link.textContent || '').trim()
    });
  }

  function trackPrivateEnquirySubmit(event) {
    if (getPath() !== TRACKED_PATHS.contact || !event.target.matches('form[action*="/contact"]')) {
      return;
    }

    publish('sb_private_enquiry_submit', {
      page_path: TRACKED_PATHS.contact,
      page_title: document.title
    });
  }


  // Optional first-arrival tracking. Store only after Shopify analytics consent.
  // Never persist full URLs, query strings, IP addresses or visitor identities.
  var SB_SOURCE_KEY = 'sb_first_arrival_v1';
  var SB_SOURCE_TTL = 30 * 24 * 60 * 60 * 1000;
  var sbCurrentArrival = null;

  function sbAnalyticsAllowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function sbSafeText(value, max) {
    return String(value || '').trim().slice(0, max || 80);
  }

  function sbDomain(value) {
    try {
      var host = new URL(value).hostname.toLowerCase();
      return /^[a-z0-9.-]+$/.test(host) ? host.slice(0, 100) : '';
    } catch (error) { return ''; }
  }

  function sbGetArrival() {
    var q = new URLSearchParams(window.location.search);
    var ref = sbDomain(document.referrer);
    var own = window.location.hostname.toLowerCase();
    if (ref === own || ref === 'www.' + own) ref = '';
    var utmSource = sbSafeText(q.get('utm_source'), 70);
    var medium = sbSafeText(q.get('utm_medium'), 50);
    var campaign = sbSafeText(q.get('utm_campaign'), 80);
    var hasAdsId = !!(q.get('gclid') || q.get('gbraid') || q.get('wbraid') || q.get('msclkid'));
    var source = utmSource || '';
    var detail = '';

    if (!source && hasAdsId) {
      source = q.has('msclkid') ? 'Microsoft Ads' : 'Google Ads';
      medium = medium || 'paid';
    } else if (!source && ref) {
      if (/(^|\.)google\.[a-z.]+$/.test(ref)) {
        source = 'Google referral';
        detail = 'Search vs Maps not established';
      } else if (/(^|\.)bing\.com$/.test(ref)) {
        source = 'Bing referral';
      } else if (/(^|\.)instagram\.com$/.test(ref) || ref === 'l.instagram.com') {
        source = 'Instagram';
      } else if (/(^|\.)facebook\.com$/.test(ref) || ref === 'l.facebook.com') {
        source = 'Facebook';
      } else {
        source = ref;
      }
      medium = medium || 'referral';
    } else if (!source) {
      source = 'Direct or unknown';
      medium = medium || 'unknown';
      detail = 'No referring source supplied';
    }

    return {
      source: source,
      medium: medium || 'tagged',
      campaign: campaign || 'Not supplied',
      landing: window.location.pathname.slice(0, 180) || '/',
      referrer: ref || 'Not supplied',
      detail: detail || (utmSource ? 'Tagged campaign' : 'Browser referral'),
      time: Date.now()
    };
  }

  function sbStoredArrival() {
    if (!sbAnalyticsAllowed()) return null;
    try {
      var raw = window.localStorage.getItem(SB_SOURCE_KEY);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved || !saved.time || Date.now() - saved.time > SB_SOURCE_TTL ||
          saved.time > Date.now() || !saved.source || !saved.landing) {
        window.localStorage.removeItem(SB_SOURCE_KEY);
        return null;
      }
      return saved;
    } catch (error) { return null; }
  }

  function sbRememberArrival() {
    if (!sbAnalyticsAllowed()) return;
    var saved = sbStoredArrival();
    if (saved) return;
    try { window.localStorage.setItem(SB_SOURCE_KEY, JSON.stringify(sbCurrentArrival)); }
    catch (error) { /* Storage can be restricted. */ }
  }

  function sbFillEnquiryAttribution() {
    if (getPath() !== TRACKED_PATHS.contact) return;
    var form = document.querySelector('form[action*="/contact"]');
    if (!form) return;
    // A source observed on this visit is useful even if storage is unavailable.
    // A previous first visit is only retained when analytics consent permits.
    var source = sbStoredArrival() || sbCurrentArrival || sbGetArrival();
    var fields = {
      'sb-attribution-source': source.source,
      'sb-attribution-medium': source.medium,
      'sb-attribution-landing': source.landing,
      'sb-attribution-referrer': source.referrer,
      'sb-attribution-campaign': source.campaign,
      'sb-attribution-detail': sbStoredArrival() ? source.detail + '; consented first arrival' :
        source.detail + '; current visit only, initial discovery not confirmed'
    };
    Object.keys(fields).forEach(function (id) {
      var input = document.getElementById(id);
      if (input && form.contains(input)) input.value = sbSafeText(fields[id], 220);
    });
  }

  sbCurrentArrival = sbGetArrival();
  sbRememberArrival();
  document.addEventListener('visitorConsentCollected', function () {
    sbRememberArrival();
    sbFillEnquiryAttribution();
  });
  document.addEventListener('DOMContentLoaded', sbFillEnquiryAttribution);
  document.addEventListener('submit', sbFillEnquiryAttribution, true);

  document.addEventListener('click', trackConsultationCta, true);
  document.addEventListener('click', trackLocationSelection, true);
  document.addEventListener('click', trackPrivateEnquiryClick, true);
  document.addEventListener('click', trackWhatsAppClick, true);
  document.addEventListener('submit', trackPrivateEnquirySubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPageState);
  } else {
    trackPageState();
  }
})();
